import { useEffect } from "react";
import moment from "moment";
export function formatDate(ci) {
  return moment(ci.value)
    .local()
    .format("DD MMM YYYY");
}

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

export const deg2rad = deg => {
  return deg * (Math.PI / 180);
};


export const useOnClickOutside =(ref, handler) =>{
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}


export function downloadExcel(data) {
  // const header = `_id,plateNumber,deviceId,direction,entryTime,exitTime,isActive,isViolation,locationId,createdAt,updatedAt`;
  const csvContent = [data].join("\n");

  // Create a Blob from the CSV string
  const csvBlob = new Blob([csvContent], { type: "text/csv" });

  // Create a download link
  const link = document.createElement("a");
  link.href = URL.createObjectURL(csvBlob);
  link.download = "Bericht.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
